import * as React from 'react';
import { Accordion, Button } from '../common';
import {InvoiceStatus} from "../../@types";
import {useEffect} from "react";

interface ExpenseFilterProps {
  setType: (value: boolean) => void;
  type?: boolean | null;
  paymentMethod?: string | null;
  onClose: () => void;
  setPaymentMethod: (value: string) => void;
  onSubmit: (e: React.ChangeEvent<HTMLFormElement>) => void;
  showFilter: boolean;
}

const ExpenseFilterComponent: React.FC<ExpenseFilterProps> = (props) => {
  const [localBillable, setLocalLocalBillable] = React.useState<boolean | undefined>(props.type ? props.type  : undefined);
  const [localPaymentMethod, setLocalPaymentMethod] = React.useState<string | null>(props.paymentMethod ? props.paymentMethod  : '');

  useEffect(() => {
    if(localBillable || localBillable === false) {
      props.setType(localBillable);
    }
    props.setPaymentMethod(localPaymentMethod as string);
  }, [localBillable, localPaymentMethod]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const modalContent = document.getElementById('modal-content');

      if (modalContent && !modalContent.contains(event.target as Node)) {
     
        props.onClose(); 
      }
    };

    window.addEventListener('mousedown', handleOutsideClick);

    return () => {
      window.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [props]);

  return (
    <div>
     {props.showFilter && (
    <div id="modal-content">
      <form onSubmit={props.onSubmit} className="w-[434px] py-4">
        <Accordion
          items={[
            {
              title: 'Type',
              content: (
                <>
                  <label htmlFor="billable" className="block mb-3">
                    <input
                      type="radio"
                      name="billable"
                      id="type"
                      value="true"
                      checked={localBillable}
                      onChange={() => setLocalLocalBillable(true)}
                    />
                    <span className="ml-3 inline-block text-gray-900">Billable</span>
                  </label>
                  <label htmlFor="non-billable" className="block mb-3">
                    <input
                      onClick={console.log}
                      type="radio"
                      name="non-billable"
                      id="non-billable"
                      value="non-billable"
                      checked={(localBillable !== true) && (localBillable !== undefined)}
                      onChange={() => setLocalLocalBillable(false)}
                    />
                    <span className="ml-3 inline-block text-gray-900">Non-Billable</span>
                  </label>
                </>
              ),
            },
            {
              title: 'Payment Method',
              content: (
                <>
                  <label htmlFor="cash" className="block mb-3">
                    <input
                      type="radio"
                      name="paymentMethod"
                      id="payment-cash"
                      value="cash"
                      checked={localPaymentMethod === 'cash'}
                      onChange={({ target }) => setLocalPaymentMethod(target.value)}
                    />
                    <span className="ml-3 inline-block text-gray-900">Cash</span>
                  </label>
                  <label htmlFor="payment-card" className="block mb-3">
                    <input
                      type="radio"
                      name="paymentMethod"
                      id="payment-card"
                      value="card"
                      checked={localPaymentMethod === 'card'}
                      onChange={({ target }) => setLocalPaymentMethod(target.value)}
                    />
                    <span className="ml-3 inline-block text-gray-900">Card</span>
                  </label>
                  <label htmlFor="Bank Transfer" className="block mb-3">
                    <input
                      type="radio"
                      name="Bank Transfer"
                      id="Bank Transfer"
                      value="transfer"
                      checked={localPaymentMethod === 'transfer'}
                      onChange={({ target }) => setLocalPaymentMethod(target.value)}
                    />
                    <span className="ml-3 inline-block text-gray-900">Transfer</span>
                  </label>
                  <label htmlFor="payment-gateway" className="block mb-3">
                    <input
                      type="radio"
                      name="paymentMethod"
                      id="payment-gateway"
                      value="payment-gateway"
                      checked={localPaymentMethod === 'payment-gateway'}
                      onChange={({ target }) => setLocalPaymentMethod(target.value)}
                    />
                    <span className="ml-3 inline-block text-gray-900">Payment Gateway</span>
                  </label>
                </>
              ),
            },
          ]}
        />
        <div className="my-[20px] justify-center flex">
          <Button text="Select" size="small" />
        </div>
      </form>
      </div>
     )}
    </div>
  );
};

export default ExpenseFilterComponent;
